import { render, staticRenderFns } from "./AutoGrowTextarea.vue?vue&type=template&id=59c5a7c5&scoped=true"
import script from "./AutoGrowTextarea.vue?vue&type=script&lang=js"
export * from "./AutoGrowTextarea.vue?vue&type=script&lang=js"
import style0 from "./AutoGrowTextarea.vue?vue&type=style&index=0&id=59c5a7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5a7c5",
  null
  
)

export default component.exports